import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'deltacapita-content-loader',
    templateUrl: './content-loader.component.html',
    styleUrls: ['./content-loader.component.scss'],
    standalone: false
})
export class ContentLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
